import * as React from "react";
import { useJoinDrawerUserExperience } from "../../../Common";

export const ReactWishlistGuestDrawerProvider: React.FunctionComponent = (
  props
) => {
  const {
    handleBeginTheJoinDrawerUserExperience,
    handleBeginTheJoinDrawerUserExperience_startingFromRegister,
  } = useJoinDrawerUserExperience();

  React.useEffect(() => {
    window.addEventListener(
      `handle-guest-wishlist-page-login-button-click`,
      handleBeginTheJoinDrawerUserExperience
    );
    return () => {
      window.removeEventListener(
        `handle-guest-wishlist-page-login-button-click`,
        handleBeginTheJoinDrawerUserExperience
      );
    };
  }, [handleBeginTheJoinDrawerUserExperience]);

  React.useEffect(() => {
    window.addEventListener(
      `handle-guest-wishlist-page-register-button-click`,
      handleBeginTheJoinDrawerUserExperience_startingFromRegister
    );
    return () => {
      window.removeEventListener(
        `handle-guest-wishlist-page-register-button-click`,
        handleBeginTheJoinDrawerUserExperience_startingFromRegister
      );
    };
  }, [handleBeginTheJoinDrawerUserExperience_startingFromRegister]);

  return <React.Fragment>{props.children || []}</React.Fragment>;
};
